import { defineStore } from 'pinia'

import type Location from '../classes/Location'
import type User from '../classes/User'
import type FlashMessage from '../types/FlashMessage'

import UserService from '../services/User';
import { useFlashMessageStore } from './flashMessages';

// export const useUserStore = defineStore('user', () => {
export const useUserStore = defineStore({
  id: "userStore",
  state: () => ({
    userLocation: null as (Location | null),
    user: null as (User | null)
  }),
  actions: {
    setUserLocation(location: Location) {
      this.userLocation = location;
      localStorage.setItem("mypiadaCurrentLocation", location.id.toString());
    },
    login(email: string, password: string, basket_id: string): Promise<any> {
      const flashMessageStore = useFlashMessageStore()
      return new Promise((resolve, reject) => {
        UserService.login(email, password, basket_id).then((userObj) => {
          this.user = userObj
        }).catch((error: Error) => {
          const message = {
              id: Math.round(Date.now() / 1000),
              messageType: "danger",
              text: error.message,
              headline: "Error",
              delay: 0, // ms
              icon: "",
              cssClass: "",
          } as FlashMessage;
          flashMessageStore.addMessage(message);

          reject(error);
        }); 
      })
    },
    fetchUser(): Promise<any>  {
      return new Promise((resolve, reject) => {
        UserService.fetchUser().then((userObj) => {
          this.user = userObj
          resolve(userObj);
        }).catch((error: Error) => {
          // Got an error
          reject(error);
        })
      })
    },
    fetchBillingAccounts(): Promise<any> {
      return new Promise((resolve, reject) => {
        UserService.fetchBillingAccounts().then((accts) => {
          resolve(accts);
        }).catch((error: Error) => {
          reject(error)
        })
      })
    },
    fetchRewards(): Promise<any> {
      return new Promise((resolve, reject) => {
        UserService.fetchRewards().then((rewardsPrograms) => {
          resolve(rewardsPrograms);
        }).catch((error: Error) => {
          reject(error)
        })
      })
    }
  }
})
